// Measure when a product is added to a shopping cart
//https://developers.google.com/tag-manager/ecommerce-ga4#add_a_product_to_a_shopping_cart
function pushGAEcommerceDataLayer(eventGA4DataJson, eventUADataJson) {
    dataLayer.push({
        ecommerce: null,
        'gtm-ee-event-category': undefined,
        'gtm-ee-event-action': undefined,
        'gtm-ee-event-non-interaction': undefined,
    });
    dataLayer.push(JSON.parse(eventGA4DataJson));
    dataLayer.push(JSON.parse(eventUADataJson));
}


function pushGAClearEcommerceDataLayer() {
    window.dataLayer.push({
        ecommerce: null,
        'gtm-ee-event-category': undefined,
        'gtm-ee-event-action': undefined,
        'gtm-ee-event-non-interaction': undefined,
    });
}

function getItemsGA4Arr(itemsArrJson) {
    let itemsGA4Arr = [];
    itemsArrJson.forEach(function(item) {
        itemsGA4Arr.push(JSON.parse(item.GA4));
    });
    return itemsGA4Arr;
}

function getItemsUAArr(itemsArrJson) {
    let itemsUAArr = [];
    itemsArrJson.forEach(function(item) {
        itemsUAArr.push(JSON.parse(item.UA));
    });
    return itemsUAArr;
}

function pushGAEcommercePurchaseEvent(orderId, total_summ, tax, itemsJson) {
    let currency = 'EUR';
    let itemsGA4Arr = JSON.parse(itemsJson['GA4']);
    let itemsUAArr = JSON.parse(itemsJson['UA']);

    pushGAClearEcommerceDataLayer()

    window.dataLayer.push({
        'event': 'purchase',
        'ecommerce': {
            'transaction_id': orderId,
            'affiliation': 'Pilgway',
            'value': total_summ,
            'tax': tax,
            'currency': currency,
            'items': itemsGA4Arr
        }
    });

    pushUAEcommercePurchaseEvent(orderId, total_summ, tax, itemsUAArr)
}

function pushUAEcommercePurchaseEvent(orderId, total_summ, tax, itemsUAArr) {
    let currency = 'EUR';
    var pushEventJson = {
        'ecommerce': {
            'currencyCode': currency,
            'purchase': {
                'actionField': {
                    'id': orderId,
                    'affiliation': 'Pilgway',
                    'revenue': total_summ,
                    'tax': tax
                },
                'products': itemsUAArr,
            }
        },
        'event': 'gtm-ee-event',
        'gtm-ee-event-category': 'Enhanced Ecommerce',
        'gtm-ee-event-action': 'Purchase',
        'gtm-ee-event-non-interaction': 'False',
    };

    window.dataLayer.push(pushEventJson);
}



function pushGAEcommerceCheckoutEvent(itemsArrJson) {
    console.log(itemsArrJson);

    let event_name = 'begin_checkout';
    let currency = 'EUR';


    let itemsGA4Arr = JSON.parse(itemsArrJson['GA4']);
    let itemsUAArr = JSON.parse(itemsArrJson['UA']);

    pushGAClearEcommerceDataLayer();

    dataLayer.push({
        'event': event_name,
        'ecommerce': {
            'currency': currency,
            'items': itemsGA4Arr
        }
    });

    pushUAEcommerceCartEvent(event_name, currency, itemsUAArr)
}


function pushGAEcommerceCartEvent(event_name, itemsArrJson) {
    console.log(itemsArrJson);
    let currency = 'EUR';
    var itemsGA4Arr = getItemsGA4Arr(itemsArrJson);
    var itemsUAArr = getItemsUAArr(itemsArrJson);

    pushGAClearEcommerceDataLayer();

    dataLayer.push({
        'event': event_name,
        'ecommerce': {
            'currency': currency,
            'items': itemsGA4Arr
        }
    });

    pushUAEcommerceCartEvent(event_name, currency, itemsUAArr)
}
function pushUAEcommerceCartEvent(event_name, currency, itemsUAArr) {
    if(event_name == 'add_to_cart'){
        var pushEventJson = {
            'ecommerce': {
                'currencyCode': currency,
                'add': {
                    'products': itemsUAArr,
                }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
            'gtm-ee-event-non-interaction': 'False',
        };
    }

    if(event_name == 'remove_from_cart'){
        pushEventJson = {
            'ecommerce': {
                'currencyCode': currency,
                'remove': {
                    'products': itemsUAArr,
                }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Removing a Product from a Shopping Cart',
            'gtm-ee-event-non-interaction': 'False',
        };
    }

    if(event_name == 'begin_checkout'){
        pushEventJson = {
            'ecommerce': {
                'currencyCode': currency,
                'checkout': {
                    'actionField': {'step': 2},
                    'products': itemsUAArr,
                }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Checkout Step 2',
            'gtm-ee-event-non-interaction': 'False',
        };
    }

    dataLayer.push(pushEventJson);

}



function pushGADataLayer(dataToPush) {
    //dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

    dataLayer.push(dataToPush);
}

function facebookPixelEvent(event, productTitle, price, userTypeName, licenseTypeName, floating, currency='EUR') {
    console.log('facebookPixelEvent');
    var data = {
        'content_name': productTitle +' '+ userTypeName +' '+ licenseTypeName,
        'value': price,
        'currency': currency,
    }

    if(floating) {
        data.content_name = data.content_name + ' Floating';
    }

    //fbq('track', event, data);
}


function getCookie(name)
{
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2];
    }
    else{
        return '';
    }
}